import { useState, useEffect } from 'react'

export function useScreenSize() {
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isSmallLaptop, setIsSmallLaptop] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.matchMedia('(max-width: 768px)').matches
      const isTablet = window.matchMedia('(min-width: 769px) and (max-width: 1024px)').matches
      const isSmallLaptop = window.matchMedia('(min-width: 1025px) and (max-width: 1366px)').matches

      setIsSmallScreen(isMobile || isTablet || isSmallLaptop)
      setIsMobile(isMobile)
      setIsTablet(isTablet)
      setIsSmallLaptop(isSmallLaptop)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return { isSmallScreen, isMobile, isTablet, isSmallLaptop }
}
